module.exports = __webpack_public_path__ + "img/003.5c8e58df.jpg";